import { useMutation } from 'hooks/useMutation'
import { useQueryClient } from 'hooks/useQueryClient'

import { deleteBookmark as deleteBookmarkQuery, postBookmark } from 'utils/queries/bookmarks'

import { Post } from 'types/post'

import { useCurrentUser } from './useCurrentUser'
import { useInfiniteBookmarks } from './useInfiniteBookmarks'

export const useBookmark = ({ post }: { post: Post }) => {
  const queryClient = useQueryClient()
  const { data: currentUser } = useCurrentUser()
  const { data: bookmarks } = useInfiniteBookmarks({ userId: currentUser?.id })

  let isBookmarked = false
  let bookmarkId: string | undefined

  const filteredBookmarks = post
    ? bookmarks?.filter((bookmark) => bookmark?.post.id === post.id) ?? []
    : []

  if (filteredBookmarks.length > 0) {
    isBookmarked = true
    bookmarkId = filteredBookmarks[0].id
  }

  const saveBookmark = useMutation(
    async () => {
      if (!currentUser || !post.id) throw new Error('Error saving bookmark')
      const result = await postBookmark({
        user: { id: currentUser.id },
        post,
        created: Date.now(),
      })
      return result
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['bookmarks'])
      },
    },
  )

  const deleteBookmark = useMutation(
    async () => {
      if (!bookmarkId) throw new Error('Error deleting bookmark')
      return deleteBookmarkQuery({ bookmarkId })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['bookmarks'])
      },
    },
  )

  return {
    saveBookmark,
    deleteBookmark,
    isBookmarked,
  }
}
